import { useMemo } from 'react';

import { useFeedbackButtonsContext } from 'pages/ParentHelper/components/Chat/components/Body/components/Answer/components/FeedbackButtons/hooks';

import type { FeedbackType } from 'pages/ParentHelper/components/Chat/components/Body/components/Answer/components/FeedbackButtons/components/FeedbackDislikeDialog/types';

export const useDefaultValues = (): FeedbackType => {
  const { messageId } = useFeedbackButtonsContext();

  return useMemo(
    () => ({
      messageId,
      inspiredGlobalStudyPlatformApiModelsParentHelperAnswerFeedbackRequest: {
        liked: false,
        feedbackText: '',
        otherFeedbackText: '',
      },
    }),
    [messageId],
  );
};
